var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "BLUR-FILTER",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff3c00"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "INNER-BLUR",
    x: 11.9,
    y: 0.1,
    width: 30.1,
    height: 30,
    filterUnits: "userSpaceOnUse",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5,4)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#BLUR-FILTER)",
    fill: "#ff7600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2863",
    d: "M30.211,4.808,28.4,5.866a15.874,15.874,0,1,1-6.036-3.26l1.751-1.522a18.076,18.076,0,1,0,6.1,3.724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2867",
    d: "M23.907,10.517a8.248,8.248,0,0,1,7.04-8.448L30.652.09a10.234,10.234,0,0,0-8.743,10.244L19.691,8.118,18.63,9.177,23,13.546l4.369-4.369-1.06-1.059Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#INNER-BLUR)",
    className: "cls-4",
    fill: "none",
    stroke: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.353,29.708h-10.7l-1.5-15.214h13.7Z",
    strokeMiterlimit: 10,
    strokeWidth: 0.962
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.686,
    y2: 10.313,
    transform: "translate(14.073 16.969)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.686,
    y2: 10.313,
    transform: "translate(21.242 16.969)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.843,
    transform: "translate(12.706 27.514)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.914
  }), /*#__PURE__*/React.createElement("line", {
    y2: 10.172,
    transform: "translate(18.001 16.969)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    fill: "#f5f5f5",
    stroke: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2866",
    d: "M20.477,3.691a1,1,0,0,0-1.409-.124L15.479,6.572,15,6a1.493,1.493,0,0,0-1.018-.532,1.522,1.522,0,0,0-1.1.344L11.464,7a1.5,1.5,0,0,0-.187,2.114l.481.573-3.59,3.005A1,1,0,0,0,8.044,14.1l.329.393L20.807,4.085ZM12.045,8.472a.5.5,0,0,1,.062-.7l1.419-1.19a.5.5,0,0,1,.322-.117l.045,0a.5.5,0,0,1,.339.178l.48.574L12.525,9.045Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.c52385b5d795086c15bd647912cef96b.svg";
export { ForwardRef as ReactComponent };